
document.addEventListener("DOMContentLoaded", function() {
  const checkboxes = document.querySelectorAll(".reco-choicelist input[type='checkbox']");
  const dataCurrencyPrice = document.querySelector('#MainContent').getAttribute('data-currency');
  const originalButton = document.querySelector("product-form.product-form .product-form__buttons .product-form__submit");
  const customButtonId = "custom-add-to-cart-button";
  const priceDisplay = document.querySelector(".addpr");
  function updateAdditionalPrice() {
    let totalPrice = 0;
    checkboxes.forEach(function(checkbox) {
      if (checkbox.checked) {
        let price = parseFloat(checkbox.getAttribute("reco-data-price"));
        if (!isNaN(price)) {
          totalPrice += price;
        }
      }
    });
    const rupees = totalPrice / 100;
    if (priceDisplay) {
      priceDisplay.textContent = dataCurrencyPrice + rupees;
    }
  }

  function updateAddToCartButton() {
    const anyChecked = Array.from(checkboxes).some(chk => chk.checked);

    if (anyChecked) {
      if (originalButton) {
        originalButton.style.display = "none";
      }
      if (!document.getElementById(customButtonId)) {
        const customButton = document.createElement("button");
        customButton.id = customButtonId;
        customButton.classList.add("product-form__submit");
        customButton.innerText = "Add to Cart"; 
        customButton.addEventListener("click", handleCustomButtonClick);
        if (originalButton && originalButton.parentNode) {
          originalButton.parentNode.insertBefore(customButton, originalButton);
        }
      }
    } else {
      const customButton = document.getElementById(customButtonId);
      if (customButton && customButton.parentNode) {
        customButton.parentNode.removeChild(customButton);
      }
     
      if (originalButton) {
        originalButton.style.display = "";
      }
    }
  }
  function handleCheckboxChange() {
    updateAdditionalPrice();
    updateAddToCartButton();
  }
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener("change", handleCheckboxChange);
  });
  function handleCustomButtonClick(e) {
    e.preventDefault();
    const selectedInputs = document.querySelectorAll('.main-optional-recommended input[type="checkbox"]:checked');
    const items = Array.from(selectedInputs).map(input => ({
      quantity: 1,
      id: input.value, 
    }));

    if (items.length === 0) {
      alert("No items selected to add to the cart.");
      return;
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    })
    .then(response => {
      if (!response.ok) {
        if (response.status === 422) {
          alert("Selected product is out of stock");
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // On success, redirect to the cart page.
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error("Error adding products to the cart:", error);
    });
  }
});

